import { ConvertableMoneyPerAreaPerPeriod, ConvertableMoneyPerPeriod, Currency } from '@root/types';

export const askingRentInMoneyPerPeriod = (
  askingRent: number | undefined,
  units: 'sf/yr' | 'Mo',
  area: number | '' | null,
  currency: Currency,
): ConvertableMoneyPerPeriod | null => {
  if (!askingRent) return null;

  if (units === 'Mo') {
    return {
      magnitude: askingRent,
      type: 'money/period',
      units: {
        money: currency,
        period: 'mo',
      },
    };
  }

  return area
    ? {
        magnitude: Math.round((askingRent * area) / 12),
        type: 'money/period',
        units: {
          money: currency,
          period: 'mo',
        },
      }
    : null;
};

export const askingRentInMoneyPerAreaPerPeriod = (
  askingRent: number | undefined,
  units: 'sf/yr' | 'Mo',
  area: number | '' | null,
  currency: Currency,
): ConvertableMoneyPerAreaPerPeriod | null => {
  if (!askingRent) return null;
  if (units === 'sf/yr') {
    return {
      magnitude: askingRent,
      type: 'money/area/period',
      units: {
        area: 'sf',
        money: currency,
        period: 'year',
      },
    };
  }

  return area
    ? {
        magnitude: Math.round((askingRent * 12) / area),
        type: 'money/area/period',
        units: {
          area: 'sf',
          money: currency,
          period: 'year',
        },
      }
    : null;
};
